import { Logger } from './Logger';

export function composeLoggers(loggers: Array<Logger>): Logger {
  function log(...messages: unknown[]): void {
    loggers.forEach((logger) => logger.log(...messages));
  }

  function warn(...messages: unknown[]): void {
    loggers.forEach((logger) => logger.warn(...messages));
  }

  function info(...messages: unknown[]): void {
    loggers.forEach((logger) => logger.info(...messages));
  }

  function error(...messages: unknown[]): void {
    loggers.forEach((logger) => logger.error(...messages));
  }

  return { log, warn, info, error };
}
